import { background, borderColor, brandPrimary, header } from '@Styles/colors';
import { CssSelectors } from '@Styles/styles';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		maxWidth: 600,
		alignItems: 'center',
		paddingTop: 30,
		paddingLeft: 200,
		paddingRight: 200,
	},
	headerLogo: {
		width: 220,
	},
	tabView: {
		width: '100%',
	},
	tabViewTabs: {
		display: 'flex',
		borderBottom: `1px solid ${borderColor}`,
	},
	tabViewItem: {
		color: header,
		display: 'inline-flex',
		flexBasis: 'auto',
		fontSize: 14,
		height: 44,
		padding: '0 36px',
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		gap: THEME.spacing.sm,
	},
	tabItemSelected: {
		borderBottom: `1px solid ${brandPrimary}`,
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		alignItems: 'center',
		padding: THEME.spacing.md,
	},
	inProgressIconContainer: {
		...CssSelectors.allChildren({
			marginTop: 35,
			opacity: 0.15,
		}),
		background,
		borderRadius: '50%',
		height: 180,
		margin: '30px auto 40px',
		textAlign: 'center',
		width: 180,
	},
});
